import * as Constants from '@/lib/constants'
import store from '@/store'

export default class WebMarkersInfo {
  static getTrackColor(username, deviceId) {
    const webMarkers = store.getters.webMarkers
    for (let i = 0; i < webMarkers.length; i++) {
      const webMarker = webMarkers[i]
      if (deviceId === webMarker.deviceId && username === webMarker.username) {
        return webMarker.trackColor
      }
    }
    return Constants.TRACK_FILL_COLOR
  }

  static getTrackName(username, deviceId) {
    const webMarkers = store.getters.webMarkers
    for (let i = 0; i < webMarkers.length; i++) {
      const webMarker = webMarkers[i]
      if (deviceId === webMarker.deviceId && username === webMarker.username) {
        return webMarker.trackName
      }
    }
    return undefined
  }
}
